/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24HeroSimulacao.css';
import RedButton from '@/components/atoms/RedButton';

function Home24HeroSimulacao() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 450 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-450.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-450.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-450.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 450 && width <= 600 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-601.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-601.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-601.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 600 && width <= 800 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-800.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-800.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-800.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 800 && width <= 1280 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1280.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1280.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-1280.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1360.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1360.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-1360.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1360 && width <= 1920 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1920.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-1920.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-1920.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1920 && (
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-2560.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="assets/home24/hero-simulacao-out-25/banner-2560.png"
                  />
                  <img
                    src="assets/home24/hero-simulacao-out-25/banner-2560.png"
                    alt="Homem sorridente olhando para um carro vermelho, representando a conquista de um automóvel com financiamento no Santander."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <div className="fade-hero-santander" />
        <ContainerHome24>
          <div className="hero-contain">
            <div className="hero-texts">
              <h1 className="hero-title">A conquista do seu novo carro começa aqui!</h1>
              <h2 className="hero-sub-title">
                Simule 100% online e aproveite condições especiais com a Santander Financiamentos
              </h2>
            </div>
            <div className="hero-buttons">
              <RedButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=home-hero-banner&int_campaign=simular#/dados-pessoais"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simular
              </RedButton>
              <WhiteButton href="#santander-carousel" id="hero-button-outros-produtos">
                Outros produtos
              </WhiteButton>
            </div>
          </div>
          {/* <picture>
            <source type="image/webp" srcSet="static/home24/img-hero-desk.webp" />
            <source type="image/png" srcSet="assets/home24/img-hero-desk.png" />
            <img
              src="assets/home24/img-hero-desk.png"
              alt="Faça parte da campanha agora e apoie com sua doação em prol da transformação social. Entenda como funciona"
              className="img-hero-desk"
            />
          </picture> */}
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24HeroSimulacao;
